import { Dispatch, SetStateAction } from "react";
import { Image } from "antd";

import { NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, THEME_TYPE_LITE, NAV_STYLE_NO_HEADER_MINI_SIDEBAR, TAB_SIZE } from "../../../../constants/ApplicationConstants/ThemeSetting";
import styles from "./index.module.less";
// import wipro_pari_logo from "../../../../assets/pictures/wipro-pari-logo.png";

import { useSideBarLogo } from "./index.hook";

type SidebarLogoProps = {
  sidebarCollapsed: boolean;
  setSidebarCollapsed: Dispatch<SetStateAction<boolean>>;
};

const ImageComponent = ({ logoImagePath }: { logoImagePath: string }) => {
  return (
    <Image
      className={styles["img-style"]}
      preview={false}
      src={logoImagePath}
      alt=""
      // onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
      //   const imgElement = event.target as HTMLImageElement;
      //   imgElement.src = wipro_pari_logo;
      // }}
    />
  );
};

const SidebarLogo = ({ sidebarCollapsed, setSidebarCollapsed }: SidebarLogoProps) => {
  /* CONSTANTS */
  const config = useSideBarLogo(sidebarCollapsed, setSidebarCollapsed);

  const baseURL = process.env.REACT_APP_BASE_IMAGE_PATH;
  const imagePath = config?.userData?.config?.theme?.LOGO_IMAGE_PATH ?? "";
  const logoImagePath = `${baseURL}/${imagePath}`;

  return (
    <div className={`gx-layout-sider-header`}>
      {config?.navStyle === NAV_STYLE_FIXED || config?.navStyle === NAV_STYLE_MINI_SIDEBAR ? (
        <div className={`${styles["sider-icon"]} gx-linebar`}>
          <i className={`gx-icon-btn icon icon-menu icon-${!sidebarCollapsed ? "menu-unfold" : "menu-fold"} ${config?.themeType !== THEME_TYPE_LITE ? "gx-text-dark" : ""}`} onClick={config?.handleHideLogo} onMouseEnter={config?.handleHideLogo} />
        </div>
      ) : null}

      <span className="gx-site-logo">{(config?.navCollapsed || config?.navStyle !== NAV_STYLE_NO_HEADER_MINI_SIDEBAR || config?.width < TAB_SIZE) && <ImageComponent logoImagePath={logoImagePath} />}</span>
    </div>
  );
};

export default SidebarLogo;
